var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader"},[_c('img',{staticClass:"app-loader__rocket",attrs:{"src":require("@/assets/images/rocket.gif")}})])
}]

export { render, staticRenderFns }